// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#ctx-menu li span[data-v-740119df] {\n  font-size: 0.95rem;\n}\n.options-button[data-v-740119df] {\n  opacity: 0.4;\n  transition: all 0.4 ease;\n}\n.options-button[data-v-740119df]:hover {\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
